






























import { Vue, Component, Prop } from "vue-property-decorator";
import { fileApi } from "@/getinfo-api";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import {
  Import as IImport,
  StudentImportCsvAllOf
} from "@/api-v2/import-export/models";
import { ModelFile as IModelFile } from "@/api-v2/files/models/model-file";
import { BaseFile as IBaseFile } from "@/api-v2/files/models/base-file";
import ImportErrorList from "@/components/imports/ImportErrorList.vue";

@Component({
  components: { ImportErrorList, CustomButton, TextField, CBlock, CPage }
})
export default class ImportStudentCsvDetail extends Vue {
  @Prop() importObject!: IImport & { importType: StudentImportCsvAllOf };

  get studentsCount() {
    return this.importObject.importType?.students?.length ?? 0;
  }

  isFile(file: IModelFile | IBaseFile): file is IModelFile {
    return !!(file as IModelFile).url;
  }

  downloadFile(diskId: string, fileId: string) {
    fileApi.FileApiV2.files(diskId, [fileId]).then(res => {
      if (res.data[0]) {
        let file: IBaseFile = res.data[0];
        if (this.isFile(file)) {
          let linkToFile = document.createElement("a");
          if (file.url) {
            linkToFile.href = file.url;
            linkToFile.target = "_blank";
            linkToFile.download = file.url;
            linkToFile.click();
          }
        }
      }
    });
  }
}
